module.exports = __webpack_public_path__ + "img/难实施.a9eab002.png";